module.exports = __webpack_public_path__ + "static/store1-364515e0b63a36c6c367aa47bd1200a2.png";